import { EMPTY_OBJECT } from '../../constants/common'

import { BulletItem } from './BulletItem'

import * as styles from './BulletList.module.css'

/**
 * @import {BulletItemProps} from "./BulletItem/BulletItem"
 */

/**
 * @typedef {object} BulletListProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<BulletItemProps>} [Item]
 *
 * @property {string} [className]
 *
 * @property {BulletItemProps} [itemProps]
 *
 * @property {React.ReactNode[]} value
 */

/**
 * @param {BulletListProps} props
 */
function BulletList({
  Element = 'div',
  className = styles.BulletList,
  itemProps: {
    className: itemClassName = styles.item,
    ...itemProps
  } = EMPTY_OBJECT,
  value,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      {value.map((item, index) => (
        <BulletItem
          {...itemProps}
          className={itemClassName}
          key={index}
          value={item}
        />
      ))}
    </Element>
  )
}

export default BulletList
